export default {
  namespaced: true,
  state: () => ({
    clienteData: null,
    enderecoEntrega: null,
    dataCapaPedido: null,
    cacheRepresentantes: null,
    isConfirmarPedido: false,
    itemSelected: null,
    itemPromocaoSelected: null,
    formInfoPedido: {
      dataPrevistaEntrega: null,
      cdn_embalag: null,
      cliente: {
        clienteid: '',
        clienteiderp: '',
        uuid: '',
        condicaopagamentoid: '',
        clientetipopessoa: '',
        clientenomeabreviado: '',
        clientenomematriz: '',
        clientenomefantasia: '',
        clienterazaosocial: '',
        clientecnpj: '',
        clienteisentoie: '',
        clienteie: '',
      },
      representante: {
        representanteid: null,
        representantenomeabreviado: '',
        representantenome: '',
        representanteemail: '',
        representanteseqpedido: '',
        representanteativo: '',
        representanteendereco: '',
        representantebairro: '',
        representantecidade: '',
        ufid: null,
        paisid: null,
        representantepercentualcomissao: '',
      },
      prioridadesPedido: null,
      clienteIdErp: null,
      enderecoEntrega: null,
      canalVenda: null,
      estabelecimento: {
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
      },
      tabelaPreco: {
        tabelapreco_id: null,
        tabelapreco_descricao: '',
      },
      tipoPedidoCliente: {
        tipopedidoid: null,
        tipopedidodescricao: null,
      },
      condicaoPagamento: {
        condicaopagamentoid: null,
        condicaopagamentodescricao: null,
      },
      numeroPedidoOrderCompra: null,
      picPedido: null,
      optionsPicPedido: [],
      observacao: null,
    },
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: null,
      total: 0,
    },
    optionsCodPagamento: [],
    optionsTabelaPreco: [],
    optionsTipoPedidoCliente: [],

    loadingRepresentante: false,
    loadingCliente: false,
    loadingCondPagamento: false,
    loadingTabelaPreco: false,
    isLoading: false,
    representanteReadonly: false,
    clienteReadonly: false,
  }),
  mutations: {
    SET_REPRESENTANTE_READONLY(state, payload) {
      state.representanteReadonly = payload;
    },
    SET_CLIENTE_READONLY(state, payload) {
      state.clienteReadonly = payload;
    },
    SET_CLIENTE_DATA(state, payload) {
      state.clienteData = payload.clienteData;
      state.enderecoEntrega = payload.enderecoEntrega;
      state.dataCapaPedido = payload.dataCapaPedido;
    },
    SET_CACHE_REPRESENTANTES(state, representantes) {
      state.cacheRepresentantes = representantes;
    },
    SET_IS_CONFIRMA_PEDIDO(state, payload) {
      state.isConfirmarPedido = payload;
    },
    SET_TIPO_PEDIDOS(state, payload) {
      state.tipoPedidos = payload;
    },
    SET_FORM_INFO_PEDIDO(state, payload) {
      state.formInfoPedido = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_REPRESENTANTE_FORM(state, payload) {
      state.formInfoPedido.representante = payload;
    },
    SET_CLIENTE_FORM(state, payload) {
      state.formInfoPedido.cliente = payload;
    },
    SET_PRIORIDADE_PEDIDO_FORM(state, payload) {
      state.formInfoPedido.prioridadesPedido = payload;
    },
    SET_CLIENTE_ID_ERP(state, payload) {
      state.formInfoPedido.clienteIdErp = payload;
    },
    SET_TIPO_ENDERECO_ID(state, payload) {
      state.formInfoPedido.tipoEnderecoId = payload;
    },
    SET_ENDERECO_ENTREGA(state, payload) {
      state.formInfoPedido.enderecoEntrega = payload;
    },
    SET_CANAIS_VENDA(state, payload) {
      state.formInfoPedido.canalVenda = payload;
    },
    SET_ESTABELECIMENTO(state, payload) {
      state.formInfoPedido.estabelecimento = payload;
    },
    SET_TABELA_PRECO(state, payload) {
      state.formInfoPedido.tabelaPreco = payload;
    },
    SET_LOADING_REPRESENTANTE(state, payload) {
      state.loadingRepresentante = payload;
    },
    SET_LOADING_CLIENTE(state, payload) {
      state.loadingCliente = payload;
    },
    SET_OPTIONS_COND_PAGAMENTO(state, payload) {
      state.optionsCodPagamento = payload;
    },
    SET_OPTIONS_TABELA_PRECO(state, payload) {
      state.optionsTabelaPreco = payload;
    },
    SET_LOADING_COND_PAGAMENTO(state, payload) {
      state.loadingCondPagamento = payload;
    },
    SET_LOADING_TABELA_PRECO(state, payload) {
      state.loadingTabelaPreco = payload;
    },
    SET_CONDICAO_PAGAMENTO_FORM(state, payload) {
      state.formInfoPedido.condicaoPagamento = payload;
    },
    SET_DATA_PREVISTA_ENTREGA_FORM(state, payload) {
      state.formInfoPedido.dataPrevistaEntrega = payload;
    },
    SET_NUMERO_PEDIDO_ORDER_COMPRA_FORM(state, payload) {
      state.formInfoPedido.numeroPedidoOrderCompra = payload;
    },
    SET_ITEM_SELECTED(state, payload) {
      state.itemSelected = payload;
    },
    SET_ITEM_PROMOCAO_SELECTED(state, payload) {
      state.itemPromocaoSelected = payload;
    },
    SET_EMBALEGEM_FORM(state, payload) {
      state.formInfoPedido.cdn_embalag = payload;
    },
    SET_TIPO_PEDIDO_CLIENTE(state, payload) {
      state.formInfoPedido.tipoPedidoCliente = payload;
    },
    SET_OPTIONS_TIPO_PEDIDO_CLIENTE(state, payload) {
      state.optionsTipoPedidoCliente = payload;
    },
    SET_OPTIONS_PIC_PEDIDO(state, payload) {
      state.formInfoPedido.optionsPicPedido = payload;
    },
    SET_PIC_PEDIDO(state, payload) {
      state.formInfoPedido.picPedido = payload;
    },
  },
  getters: {
    GET_CLIENTE_DATA: (state) => state.clienteData,
    GET_ENDERECO_ENTREGA: (state) => state.enderecoEntrega,
    GET_DATA_CAPA_PEDIDO: (state) => state.dataCapaPedido,
    GET_COND_PAGTOS_FORM(state) {
      return state.formInfoPedido.condicaoPagamento;
    },
    GET_FORM_INFO_PEDIDO(state) {
      return state.formInfoPedido;
    },
    GET_FILTERS(state) {
      return state.filters;
    },
    GET_IS_LOADING(state) {
      return state.isLoading;
    },
    GET_TIPO_PEDIDOS_CLIENTE(state) {
      return state.tipoPedidos;
    },
    GET_LOADING_REPRESENTANTE(state) {
      return state.loadingRepresentante;
    },
    GET_LOADING_CLIENTE(state) {
      return state.loadingCliente;
    },
    GET_LOADING_COND_PAGAMENTO(state) {
      return state.loadingCondPagamento;
    },
    GET_LOADING_TABELA_PRECO(state) {
      return state.loadingTabelaPreco;
    },
    GET_OPTIONS_TABELA_PRECO(state) {
      return state.optionsTabelaPreco;
    },
    GET_OPTIONS_CONDICAO_PAGAMENTO(state) {
      return state.optionsCodPagamento;
    },
    GET_OPTIONS_TIPO_PEDIDO_CLIENTE(state) {
      return state.formInfoPedido.tipoPedido;
    },
    GET_CLIENT_ID_ERP(state) {
      return state.formInfoPedido.cliente;
    },
    GET_CLIENTE_ID(state) {
      return state.formInfoPedido.cliente.clienteid;
    },
    GET_REPRESENTANTE_ID(state) {
      return state.formInfoPedido.representante.representanteid;
    },
    GET_IS_CONFIRMAR_PEDIDO(state) {
      return state.isConfirmarPedido;
    },
    GET_VALIDATION_FORM_INFO_PEDIDO(state) {
      const clienteExists = state.formInfoPedido && state.formInfoPedido.cliente;
      const representanteExists = state.formInfoPedido && state.formInfoPedido.representante;
      const tabelaPrecoExists = state.formInfoPedido && state.formInfoPedido.tabelaPreco;
      const condicaoPagamentoExists = state.formInfoPedido && state.formInfoPedido.condicaoPagamento;

      const validatinPedido = clienteExists && state.formInfoPedido.cliente.clienteid
                && representanteExists && state.formInfoPedido.representante.representanteid
                && tabelaPrecoExists && state.formInfoPedido.tabelaPreco.tabelapreco_id
                && condicaoPagamentoExists && state.formInfoPedido.condicaoPagamento.condicaopagamentoid;

      return validatinPedido !== '' && validatinPedido !== null;
    },
    GET_DATA_PREVISTA_ENTREGA_FORM(state) {
      return state.formInfoPedido.dataPrevistaEntrega;
    },
    GET_NUMERO_PEDIDO_ORDER_COMPRA_FORM(state) {
      return state.formInfoPedido.numeroPedidoOrderCompra;
    },
    GET_ITEM_SELECTED(state) {
      return state.itemSelected;
    },
    GET_ITEM_PROMOCAO_SELECTED(state) {
      return state.itemPromocaoSelected;
    },
    GET_EMBALAGEM_FORM(state) {
      return state.formInfoPedido.cdn_embalag;
    },
    GET_TABELE_PRECO_FORM(state) {
      return state.formInfoPedido.tabelaPreco;
    },
    GET_OPTIONS_PIC_PEDIDO(state) {
      return state.formInfoPedido.optionsPicPedido;
    },
    GET_PIC_PEDIDO(state) {
      return state.formInfoPedido.picPedido;
    },
  },
  actions: {
    async prepararModalEmbalagens({ commit, state, dispatch }) {
      if (!state.itemSelected || !state.itemPromocaoSelected) {
        await dispatch('carregarDadosProduto', state.itemSelected);
      }
    },
    async carregarDadosProduto({ commit }, produtoId) {
      const dadosProduto = await produtoService.buscarProduto(produtoId);
      commit('SET_ITEM_SELECTED', dadosProduto.itemSelected);
      commit('SET_ITEM_PROMOCAO_SELECTED', dadosProduto.itemPromocaoSelected);
    },
    async listarRepresentanteInfoPedido({ commit, state }) {
      if (!state.cacheRepresentantes) {
        const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();
        commit('SET_CACHE_REPRESENTANTES', representantes);
      }
      return state.cacheRepresentantes;
    },
    resetarRepresentanteInfoPedido({ commit }) {
      commit('SET_REPRESENTANTE_FORM', {
        representanteid: null,
        representantenomeabreviado: '',
        representantenome: '',
        representanteemail: '',
        representanteseqpedido: '',
        representanteativo: '',
        representanteendereco: '',
        representantebairro: '',
        representantecidade: '',
        ufid: null,
        paisid: null,
        representantepercentualcomissao: '',
      });
    },
    resetarClienteInfoPedido({ commit, state }) {
      console.log('resetarClienteInfoPedido');
      commit('SET_FORM_INFO_PEDIDO', {
        ...state.formInfoPedido,
        cliente: {
          clienteid: '',
          clienteiderp: '',
          uuid: '',
          condicaopagamentoid: '',
          clientetipopessoa: '',
          clientenomeabreviado: '',
          clientenomematriz: '',
          clientenomefantasia: '',
          clienterazaosocial: '',
          clientecnpj: '',
          clienteisentoie: '',
          clienteie: '',
        },
        // representante: { ...state.representante },
        prioridadesPedido: null,
        clienteIdErp: null,
        enderecoEntrega: null,
        canalVenda: null,
        estabelecimento: {
          estabelecimentoid: '',
          estabelecimentorazaosocial: '',
        },
        tabelaPreco: {
          tabelapreco_id: null,
          tabelapreco_descricao: '',
        },
        tipoPedidoCliente: {
          tipopedidoid: null,
          tipopedidodescricao: null,
        },
        condicaoPagamento: {
          condicaopagamentoid: null,
          condicaopagamentodescricao: null,
        },
        numeroPedidoOrderCompra: null,
        picPedido: null,
        optionsPicPedido: [],
        observacao: null,
      });
    },
    resetarTabelaPrecoInfoPedido({ commit }) {
      commit('SET_TABELA_PRECO', {
        tabelapreco_id: null,
        tabelapreco_descricao: '',
      });
      commit('SET_OPTIONS_TABELA_PRECO', []);
    },
    resertCondPagamentoInfoPedido({ commit }) {
      commit('SET_CONDICAO_PAGAMENTO_FORM', {
        condicaopagamentoid: null,
        condicaopagamentodescricao: null,
      });
      commit('SET_OPTIONS_COND_PAGAMENTO', []);
    },
    resertInfoPedido({ commit, state, dispatch }) {
      dispatch('resetarRepresentanteInfoPedido');
      commit('SET_FORM_INFO_PEDIDO', {
        dataPrevistaEntrega: null,
        cliente: {
          clienteid: '',
          clienteiderp: '',
          uuid: '',
          condicaopagamentoid: '',
          clientetipopessoa: '',
          clientenomeabreviado: '',
          clientenomematriz: '',
          clientenomefantasia: '',
          clienterazaosocial: '',
          clientecnpj: '',
          clienteisentoie: '',
          clienteie: '',
        },
        representante: state.formInfoPedido.representante || {
          representanteid: null,
          representantenomeabreviado: '',
          representantenome: '',
          representanteemail: '',
          representanteseqpedido: '',
          representanteativo: '',
          representanteendereco: '',
          representantebairro: '',
          representantecidade: '',
          ufid: null,
          paisid: null,
          representantepercentualcomissao: '',
        },
        prioridadesPedido: null,
        clienteIdErp: null,
        enderecoEntrega: null,
        canalVenda: null,
        estabelecimento: {
          estabelecimentoid: '',
          estabelecimentorazaosocial: '',
        },
        tabelaPreco: {
          tabelapreco_id: null,
          tabelapreco_descricao: '',
        },
        condicaoPagamento: {
          condicaopagamentoid: null,
          condicaopagamentodescricao: null,
        },
        numeroPedidoOrderCompra: null,
        observacao: null,
      });
    },

  },
};
